/* Independent visit-page behaviour. BOGOS alone adds, removes and discounts gifts. */
(() => {
  'use strict';
  if (customElements.get('lapland-visit')) return;
  customElements.define('lapland-visit', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.mediaQuery = window.matchMedia('(max-width:749px)');
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion:reduce)');
      this.hatIDs = new Set((this.dataset.hatIds || '').split(',').map(id=>id.trim()).filter(Boolean));
      this.querySelectorAll('[data-visit-open]').forEach(button=>{button.hidden=false;});
      this.addEventListener('click', event=>this.handleClick(event), options);
      this.addEventListener('change', event=>{
        if (event.target.matches('[data-visit-variant]')) this.updateVariant(event.target.closest('[data-visit-product]'));
      }, options);
      this.addEventListener('submit', event=>{
        if (!event.target.matches('.visit-form')) return;
        event.preventDefault();
        event.stopPropagation();
        this.addProduct(event.target);
      }, options);
      this.addEventListener('shopify:block:select', event=>{
        const button=event.target.querySelector('[data-visit-open]');
        if (button) this.openPanel(button,false);
      }, options);
      this.querySelectorAll('[data-visit-product]').forEach(product=>this.updateVariant(product));
      this.mediaQuery.addEventListener('change',()=>this.mountVideos(),options);
      this.reduceMotion.addEventListener('change',()=>this.mountVideos(),options);
      this.mountVideos();
      window.addEventListener('message',event=>this.receiveFrame(event),options);
      ['fg-gifts:updated','fg-cart:auto-updated','theme:product:add'].forEach(name=>document.addEventListener(name,()=>this.queueCart(),options));
      document.addEventListener('theme:cart:change',event=>{
        if (event.detail?.visitSource === this.id) return;
        if (event.detail?.cart?.items) this.drawCart(event.detail.cart);
        else this.queueCart();
      },options);
      document.addEventListener('theme:cart-drawer:open',()=>{
        if (this.cartNeedsRefresh) {this.cartNeedsRefresh=false;document.querySelector('cart-items')?.getCart?.();}
      },options);
      window.addEventListener('pageshow',()=>{this.unlock();this.queueCart();},options);
      this.queueCart();
    }
    disconnectedCallback() {
      this.controller?.abort();
      clearTimeout(this.cartTimer);
      this.querySelectorAll('video').forEach(video=>video.pause());
      this.querySelectorAll('iframe').forEach(frame=>clearTimeout(frame.visitLoadTimer));
    }
    scrollTo(element) {
      element?.scrollIntoView({block:'start',behavior:this.reduceMotion.matches?'instant':'smooth'});
    }
    handleClick(event) {
      const trigger=event.target.closest('[data-visit-open]');
      if (trigger) {this.openPanel(trigger,true);return;}
      const close=event.target.closest('[data-visit-close]');
      if (close) {
        const panel=this.querySelector('#'+CSS.escape(close.dataset.visitClose));
        this.closePanel(panel);
        this.querySelector('[aria-controls="'+CSS.escape(panel.id)+'"]')?.focus({preventScroll:true});
        return;
      }
      const native=event.target.closest('[data-visit-native]');
      if (native) {event.preventDefault();this.openNative(native);return;}
      const nativeClose=event.target.closest('[data-visit-native-close]');
      if (nativeClose) {
        const area=nativeClose.closest('[data-visit-native-area]');
        this.closeNative(area);
        this.nativeOpener?.focus({preventScroll:true});
        return;
      }
      const jump=event.target.closest('[data-visit-jump]');
      if (jump) {
        const url=new URL(jump.href,window.location.href);
        if (url.origin!==location.origin || url.pathname!==location.pathname || !url.hash) return;
        let target;
        try {target=this.querySelector('#'+CSS.escape(decodeURIComponent(url.hash.slice(1))));} catch {return;}
        if (!target) return;
        event.preventDefault();
        const shopButton=target.querySelector('[data-visit-open]');
        if (shopButton) this.openPanel(shopButton,false);
        this.scrollTo(target);
      }
    }
    openPanel(trigger,scroll) {
      const panel=this.querySelector('#'+CSS.escape(trigger.dataset.visitOpen));
      if (!panel) return;
      const audience=panel.closest('[data-visit-audience]');
      audience.querySelectorAll('[data-visit-panel]').forEach(other=>{if(other!==panel)this.closePanel(other);});
      panel.hidden=false;
      trigger.setAttribute('aria-expanded','true');
      if (scroll) this.scrollTo(panel);
    }
    closePanel(panel) {
      if (!panel) return;
      panel.hidden=true;
      this.querySelector('[aria-controls="'+CSS.escape(panel.id)+'"]')?.setAttribute('aria-expanded','false');
      panel.querySelectorAll('[data-visit-native-area]').forEach(area=>this.closeNative(area));
    }
    closeNative(area) {
      if (!area) return;
      area.hidden=true;
      const frame=area.querySelector('iframe');
      if(frame)clearTimeout(frame.visitLoadTimer);
      area.querySelector('[data-visit-frame-mount]').replaceChildren();
    }
    openNative(link) {
      const panel=link.closest('[data-visit-panel]');
      const area=panel.querySelector('[data-visit-native-area]');
      this.nativeOpener=link;
      this.closeNative(area);
      area.hidden=false;
      area.querySelector('[data-visit-native-heading]').textContent=link.dataset.visitNativeTitle;
      area.querySelector('[data-visit-native-status]').textContent='Loading your personalisation options...';
      area.querySelector('[data-visit-native-fallback]').href=link.href;
      const frame=document.createElement('iframe');
      const url=new URL(link.dataset.visitNative,location.origin);
      url.searchParams.set('view','visit-inline');
      const previewTheme=new URL(location.href).searchParams.get('preview_theme_id');
      if (previewTheme) url.searchParams.set('preview_theme_id',previewTheme);
      frame.src=url.href;
      frame.title='Choose options for '+link.dataset.visitNativeTitle;
      frame.className='visit-native-frame';
      frame.setAttribute('loading','eager');
      area.querySelector('[data-visit-frame-mount]').append(frame);
      frame.visitLoadTimer=setTimeout(()=>{
        if(frame.isConnected)area.querySelector('[data-visit-native-status]').textContent='If your options are slow to load, open the full product page below.';
      },15000);
      this.scrollTo(area);
    }
    receiveFrame(event) {
      if(event.origin!==location.origin || event.data?.source!=='lapland-visit-form')return;
      const frame=Array.from(this.querySelectorAll('.visit-native-frame')).find(candidate=>candidate.contentWindow===event.source);
      if(!frame)return;
      const area=frame.closest('[data-visit-native-area]');
      if(event.data.type==='ready' || event.data.type==='height') {
        const height=Number(event.data.height);
        if(Number.isFinite(height))frame.style.height=Math.max(420,Math.min(height,20000))+'px';
        if(event.data.type==='ready') {
          clearTimeout(frame.visitLoadTimer);
          area.querySelector('[data-visit-native-status]').textContent='Personalise each item using the options below.';
        }
      }
      if(event.data.type==='cart-changed') {
        area.querySelector('[data-visit-native-status]').textContent='Your basket has been updated. You can personalise another item below.';
        this.cartNeedsRefresh=true;
        this.queueCart();
      }
    }
    mountVideos() {
      this.querySelectorAll('[data-visit-media]').forEach(media=>{
        const mount=media.querySelector('[data-visit-video-mount]');
        if(!mount)return;
        mount.querySelector('video')?.pause();mount.replaceChildren();
        const preferred=this.mediaQuery.matches?'mobile':'desktop';
        const template=media.querySelector('template[data-visit-video="'+preferred+'"]') || media.querySelector('template[data-visit-video="desktop"]') || media.querySelector('template[data-visit-video="mobile"]');
        const picture=media.querySelector('picture');
        if(picture)picture.hidden=false;
        if(!template || media.dataset.visitAutoplay==='false' || this.reduceMotion.matches)return;
        mount.append(template.content.cloneNode(true));
        const video=mount.querySelector('video');
        if(!video)return;
        if(picture)video.poster=picture.querySelector('img')?.currentSrc || picture.querySelector('img')?.src || '';
        video.loop=media.dataset.visitLoop!=='false';
        video.addEventListener('playing',()=>{if(picture)picture.hidden=true;},{signal:this.controller.signal});
        video.addEventListener('ended',()=>{if(picture)picture.hidden=false;},{signal:this.controller.signal});
        video.addEventListener('error',()=>{if(picture)picture.hidden=false;mount.replaceChildren();},{signal:this.controller.signal});
        video.defaultMuted=true;video.muted=true;video.autoplay=true;video.playsInline=true;
        video.setAttribute('muted','');video.setAttribute('autoplay','');video.setAttribute('playsinline','');video.setAttribute('webkit-playsinline','');
        video.play().catch(()=>{mount.replaceChildren();if(picture)picture.hidden=false;});
      });
    }
    updateVariant(product) {
      const form=product.querySelector('.visit-form');
      if(!form)return;
      const id=form.querySelector('[name=id]').value;
      const info=product.querySelector('template[data-visit-variant-info="'+CSS.escape(id)+'"]');
      if(!info)return;
      product.querySelector('[data-visit-price]').textContent=info.dataset.price;
      const compare=product.querySelector('[data-visit-compare]');compare.textContent=info.dataset.compare;compare.hidden=!info.dataset.compare;
      const quantity=form.querySelector('[name=quantity]');
      quantity.min=info.dataset.min;quantity.step=info.dataset.step;
      if(info.dataset.max)quantity.max=info.dataset.max;else quantity.removeAttribute('max');
      if(!quantity.checkValidity())quantity.value=info.dataset.min;
      const button=form.querySelector('[data-visit-add]');
      button.disabled=this.busy || info.dataset.available!=='true';
      button.textContent=info.dataset.available==='true'?'Add to basket':'Sold out';
    }
    unlock() {
      this.busy=false;
      this.querySelectorAll('.visit-form').forEach(form=>{
        form.removeAttribute('aria-busy');
        form.querySelectorAll('input,select,fieldset').forEach(input=>{input.disabled=false;});
      });
      this.querySelectorAll('[data-visit-product]').forEach(product=>this.updateVariant(product));
    }
    async addProduct(form) {
      if(this.busy || !form.reportValidity())return;
      const product=form.closest('[data-visit-product]');
      const id=form.querySelector('[name=id]').value;
      const info=product.querySelector('template[data-visit-variant-info="'+CSS.escape(id)+'"]');
      if(!info || info.dataset.available!=='true')return;
      const payload=new FormData(form);
      const error=form.querySelector('[data-visit-error]');const status=form.querySelector('[data-visit-status]');
      error.hidden=true;status.textContent='Adding to your basket...';this.busy=true;
      form.setAttribute('aria-busy','true');
      this.querySelectorAll('[data-visit-add]').forEach(button=>{button.disabled=true;});
      form.querySelectorAll('input,select,fieldset').forEach(input=>{input.disabled=true;});
      form.querySelector('[data-visit-add]').textContent='Adding...';
      try {
        const response=await fetch(this.dataset.addUrl,{method:'POST',body:payload,credentials:'same-origin',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}});
        let result;
        try {result=await response.json();} catch {throw new Error('We could not confirm the basket update. Please check your basket before trying again.');}
        if(!response.ok || result.status>=400)throw new Error(result.description || result.message || 'This item could not be added. Please check availability and try again.');
        this.unlock();
        status.textContent='Added to your basket. ';
        const link=document.createElement('a');link.href=this.dataset.cartUrl;link.textContent='View basket';status.append(link);
        this.cartNeedsRefresh=true;
        this.queueCart();
      } catch(failure) {
        this.unlock();status.textContent='';
        error.textContent=failure instanceof TypeError?'We could not confirm the update. Please check your connection and basket before trying again.':failure.message;
        error.hidden=false;error.focus({preventScroll:true});
      }
    }
    queueCart() {
      clearTimeout(this.cartTimer);
      this.cartVersion=(this.cartVersion || 0)+1;
      const version=this.cartVersion;
      this.cartTimer=setTimeout(()=>this.refreshCart(version).catch(()=>{}),180);
    }
    async refreshCart(version) {
      const response=await fetch(this.dataset.cartUrl+'.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      if(!response.ok)throw new Error('Basket display could not be refreshed.');
      const cart=await response.json();
      if(version!==this.cartVersion || !this.isConnected || !Array.isArray(cart.items))return;
      this.drawCart(cart);
      document.dispatchEvent(new CustomEvent('theme:cart:change',{bubbles:true,detail:{cartCount:cart.item_count,cart,visitSource:this.id}}));
      document.dispatchEvent(new CustomEvent('bogos:progress-rerender'));
    }
    drawCart(cart) {
      const basket=this.querySelector('[data-visit-basket]');
      if(basket) {
        basket.hidden=cart.item_count<1;
        this.querySelector('[data-visit-basket-count]').textContent=cart.item_count+' '+(cart.item_count===1?'item':'items');
        try{this.querySelector('[data-visit-basket-total]').textContent=new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:cart.currency || this.dataset.currency}).format(cart.total_price/100);}catch{this.querySelector('[data-visit-basket-total]').textContent='';}
      }
      const count=cart.items.filter(item=>this.hatIDs.has(String(item.product_id))).reduce((sum,item)=>sum+item.quantity,0);
      const threshold=Number(this.dataset.hatThreshold) || 3;
      const actualGift=cart.items.some(item=>String(item.product_id)===this.dataset.boxId && Number(item.final_line_price)===0);
      this.querySelectorAll('[data-visit-hat-progress]').forEach(message=>{
        message.hidden=count===0;
        if(actualGift)message.textContent='Your free Christmas Eve box is in your basket.';
        else if(count>=threshold)message.textContent=threshold+' or more hats are in your basket. Your box will appear when the offer is applied.';
        else message.textContent='Add '+(threshold-count)+' more '+(threshold-count===1?'hat':'hats')+' for the Christmas Eve box offer.';
      });
    }
  });
})();
